<!--
~ Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
-->
<ngf-pill-list
  #pillList
  archive
  [largePills]="large"
  [showClearAll]="showClearAll"
  [showChevron]="showChevron"
  (openChanged)="openChanged.emit($event)"
  (clearAll)="clearAll.emit()"
  [positions]="positions">

  @for (t of displayedTemplates$ | async; track t) {
    <ng-container *ngTemplateOutlet="t.templateRef; context: t.context" />
  }
  <ng-template [ngfCollapsedPills]="(collapsedTemplates$ | async)?.length">
    @for (t of collapsedTemplates$ | async; track t) {
      <ng-container *ngTemplateOutlet="t.templateRef; context: t.context" />
    }
  </ng-template>

</ngf-pill-list>
